<template>
  <span v-if="statusText"  class="badge rounded-pill bg-primary" :class="statusText.class" v-bind="$attrs">
    {{statusText.text}}
  </span>
</template>

<script>
export default {
  props: {
    status: String,
    text: {
      type: String,
      default: null
    }
  },
  computed: {
    statusText() {
      
      if(this.status == 'canceled') {
        return { text: this.text ? this.text : 'ยกเลิก', class: 'bg-danger'}
      } 
      if(this.status == 'posted') {
        return {text:  this.text ? this.text : 'Post', class: 'bg-success'}
      }
      if(this.status == 'expired') {
        return {text:  this.text ? this.text : 'หมดอายุ', class: 'bg-secondary'}
      }
      // if(this.status == 'invoice') {
      //   return {text: 'ขอใบกำกับ', class: 'bg-primary'}
      // }
      return null
    },    
  }
}
</script>
<style>
.bg-orange{
  background-color: #ffae00 !important;
}
</style>